import firebase from '../services/firebase';
import { normalize, schema } from 'normalizr';
import { getPath, ORDER_DETAIL } from '../routes';
import { entitiesAdded } from './entityActions';

export const INCOMING_ORDERS_FETCHED = 'INCOMING_ORDERS_FETCHED';
export const AUDITED_ORDERS_FETCHED = 'AUDITED_ORDERS_FETCHED';
export const READY_TO_SHIP_ORDERS_FETCHED = 'READY_TO_SHIP_ORDERS_FETCHED';
export const SHIPPED_ORDERS_FETCHED = 'SHIPPED_ORDERS_FETCHED';
export const ARCHIVED_ORDERS_FETCHED = 'ARCHIVED_ORDERS_FETCHED';
export const ORDER_FETCHED = 'ORDER_FETCHED';

const unsubscribes = {};
const colRef = firebase.firestore().collection('orders');

function transformDoc(doc) {
  return {
    id: doc.id,
    url: getPath(ORDER_DETAIL, doc.id),
    ...doc.data()
  };
}

function transformCollection(querySnapshot) {
  const collection = [];
  querySnapshot.forEach(doc => collection.push(transformDoc(doc)));
  return collection;
}

export function listenToIncomingOrders() {
  return dispatch => {
    if (!unsubscribes[INCOMING_ORDERS_FETCHED]) {
      unsubscribes[INCOMING_ORDERS_FETCHED] = colRef
        .where('status', '==', 'incoming')
        .orderBy('created')
        .onSnapshot(querySnapshot => {
          const collection = transformCollection(querySnapshot);
          const { entities, result } = normalize(collection, [
            new schema.Entity('orders')
          ]);
          dispatch(entitiesAdded('orders', entities.orders));
          dispatch({
            type: INCOMING_ORDERS_FETCHED,
            payload: result
          });
        });
    }
  };
}

export function silenceIncomingOrders() {
  return () => {
    if (unsubscribes[INCOMING_ORDERS_FETCHED]) {
      unsubscribes[INCOMING_ORDERS_FETCHED]();
      delete unsubscribes[INCOMING_ORDERS_FETCHED];
    }
  };
}

export function listenToAuditedOrders() {
  return dispatch => {
    if (!unsubscribes[AUDITED_ORDERS_FETCHED]) {
      unsubscribes[AUDITED_ORDERS_FETCHED] = colRef
        .where('status', '==', 'audited')
        .orderBy('created')
        .onSnapshot(querySnapshot => {
          const collection = transformCollection(querySnapshot);
          const { entities, result } = normalize(collection, [
            new schema.Entity('orders')
          ]);
          dispatch(entitiesAdded('orders', entities.orders));
          dispatch({
            type: AUDITED_ORDERS_FETCHED,
            payload: result
          });
        });
    }
  };
}

export function silenceAuditedOrders() {
  return () => {
    if (unsubscribes[AUDITED_ORDERS_FETCHED]) {
      unsubscribes[AUDITED_ORDERS_FETCHED]();
      delete unsubscribes[AUDITED_ORDERS_FETCHED];
    }
  };
}

export function listenToReadyToShipOrders() {
  return dispatch => {
    if (!unsubscribes[READY_TO_SHIP_ORDERS_FETCHED]) {
      unsubscribes[READY_TO_SHIP_ORDERS_FETCHED] = colRef
        .where('status', '==', 'readyToShip')
        .orderBy('created')
        .onSnapshot(querySnapshot => {
          const collection = transformCollection(querySnapshot);
          const { entities, result } = normalize(collection, [
            new schema.Entity('orders')
          ]);
          dispatch(entitiesAdded('orders', entities.orders));
          dispatch({
            type: READY_TO_SHIP_ORDERS_FETCHED,
            payload: result
          });
        });
    }
  };
}

export function silenceReadyToShipOrders() {
  return () => {
    if (unsubscribes[READY_TO_SHIP_ORDERS_FETCHED]) {
      unsubscribes[READY_TO_SHIP_ORDERS_FETCHED]();
      delete unsubscribes[READY_TO_SHIP_ORDERS_FETCHED];
    }
  };
}

export function listenToShippedOrders() {
  return dispatch => {
    if (!unsubscribes[SHIPPED_ORDERS_FETCHED]) {
      unsubscribes[SHIPPED_ORDERS_FETCHED] = colRef
        .where('status', '==', 'shipped')
        .orderBy('created')
        .onSnapshot(querySnapshot => {
          const collection = transformCollection(querySnapshot);
          const { entities, result } = normalize(collection, [
            new schema.Entity('orders')
          ]);
          dispatch(entitiesAdded('orders', entities.orders));
          dispatch({
            type: SHIPPED_ORDERS_FETCHED,
            payload: result
          });
        });
    }
  };
}

export function silenceShippedOrders() {
  return () => {
    if (unsubscribes[SHIPPED_ORDERS_FETCHED]) {
      unsubscribes[SHIPPED_ORDERS_FETCHED]();
      delete unsubscribes[SHIPPED_ORDERS_FETCHED];
    }
  };
}

export function listenToArchivedOrders() {
  return dispatch => {
    if (!unsubscribes[ARCHIVED_ORDERS_FETCHED]) {
      unsubscribes[ARCHIVED_ORDERS_FETCHED] = colRef
        .where('status', '==', 'archived')
        .orderBy('created', 'desc')
        .limit(10)
        .onSnapshot(querySnapshot => {
          const collection = transformCollection(querySnapshot);
          const { entities, result } = normalize(collection, [
            new schema.Entity('orders')
          ]);
          dispatch(entitiesAdded('orders', entities.orders));
          dispatch({
            type: ARCHIVED_ORDERS_FETCHED,
            payload: result
          });
        });
    }
  };
}

export function silenceArchivedOrders() {
  return () => {
    if (unsubscribes[ARCHIVED_ORDERS_FETCHED]) {
      unsubscribes[ARCHIVED_ORDERS_FETCHED]();
      delete unsubscribes[ARCHIVED_ORDERS_FETCHED];
    }
  };
}

export function listenToOrder(orderId) {
  return dispatch => {
    if (!unsubscribes[`orders.${orderId}`]) {
      unsubscribes[`orders.${orderId}`] = colRef
        .doc(orderId)
        .onSnapshot(doc => {
          dispatch(entitiesAdded('orders', { [orderId]: transformDoc(doc) }));
        });
    }
  };
}

export function silenceOrder(orderId) {
  return dispatch => {
    if (unsubscribes[`orders.${orderId}`]) {
      unsubscribes[`orders.${orderId}`]();
      delete unsubscribes[`orders.${orderId}`];
    }
  };
}

export function saveAuditReport(orderId, auditReport) {
  return dispatch => {
    return firebase
      .firestore()
      .doc(`orders/${orderId}`)
      .update({ auditReport });
  };
}

export function markShipped(orderId) {
  return dispatch => {
    return firebase
      .firestore()
      .doc(`orders/${orderId}`)
      .update({ status: 'shipped' });
  };
}



// WEBPACK FOOTER //
// ./src/actions/orderActions.js